<template>
    <div>
       <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "Activity"
    }
</script>

<style scoped>

</style>
